import type { IconName, SvgIconProps } from "./types";

function outlineProps(props: SvgIconProps) {
  return {
    ...props,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    strokeWidth: 1.8,
    viewBox: "0 0 24 24",
  };
}

const RightOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M9 5l7 7-7 7" />
  </svg>
);

const LeftOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M15 5l-7 7 7 7" />
  </svg>
);

const DownOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const XOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M7 7l10 10" />
    <path d="M17 7L7 17" />
  </svg>
);

const PlusOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </svg>
);

const SearchOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <circle cx="11" cy="11" r="6" />
    <path d="M16 16l4 4" />
  </svg>
);

const FilterOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M4 6h16" />
    <path d="M7 12h10" />
    <path d="M10 18h4" />
  </svg>
);

const SaveOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M5 4h11l3 3v13H5z" />
    <path d="M8 4v6h8" />
    <path d="M8 20v-6h8v6" />
  </svg>
);

const UploadOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M12 16V5" />
    <path d="M7 10l5-5 5 5" />
    <path d="M5 19h14" />
  </svg>
);

const EditOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M4 20h4l11-11a2.8 2.8 0 0 0-4-4L4 16z" />
    <path d="M13 6l5 5" />
  </svg>
);

const DeleteOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M5 7h14" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M8 7l1-3h6l1 3" />
    <path d="M7 7l1 13h8l1-13" />
  </svg>
);

const LogoutOutline = (props: SvgIconProps) => (
  <svg {...outlineProps(props)}>
    <path d="M14 7.5V5.75C14 4.78 13.22 4 12.25 4H6.75C5.78 4 5 4.78 5 5.75v12.5C5 19.22 5.78 20 6.75 20h5.5c.97 0 1.75-.78 1.75-1.75V16.5" />
    <path d="M10 12h8.25" />
    <path d="m15.25 8.75 3.25 3.25-3.25 3.25" />
  </svg>
);

export const iconMap: Record<IconName, { fill?: typeof RightOutline; outline?: typeof RightOutline }> = {
  delete: { outline: DeleteOutline },
  down: { outline: DownOutline },
  edit: { outline: EditOutline },
  filter: { outline: FilterOutline },
  left: { outline: LeftOutline },
  logout: { outline: LogoutOutline },
  plus: { outline: PlusOutline },
  right: { outline: RightOutline },
  save: { outline: SaveOutline },
  search: { outline: SearchOutline },
  upload: { outline: UploadOutline },
  x: { outline: XOutline },
};
